import React, { useEffect } from 'react';
import { submitMockTest } from '../../../../actions/mock-test';
import { useDispatch } from 'react-redux';
import KatexViewer from '@/helpers/Katex';

//single choice image template
const Template2 = ({
  question,
  model,
  section,
  scrollToQ,
  answers,
  setAns,
  setAnswer,
}) => {
  const dispatch = useDispatch();
  // useEffect(()=>{
  //     setQcounter(qCounter+1)
  // },[])
  useEffect(() => {
    try {
      var elmnt = document.getElementById('q-' + scrollToQ);
      const y = elmnt.getBoundingClientRect().top + window.scrollY - 200;
      window.scroll({
        top: y,
        behavior: 'smooth',
      });
      elmnt.focus();
    } catch (err) {
      // console.log('doesnot exist');
    }
    //window.scroll(0,findPos(elmnt));
  }, [scrollToQ]);

  const option = ['A', 'B', 'C', 'D', 'E', 'F', 'G'];
  const onAnswered = (q, ans, id) => {
    setAnswer((answers) => {
      return { ...answers, [q]: ans };
    });
    let obj = answers.find((o) => o.question_id == question.id);
    let idx = answers.findIndex((o) => o.question_id == question.id);

    //obj.answer_id= id
    // console.log("Call from on Answered ",'q:',q,'ams',ans,"id",id)

    setAns((prevans) => [
      ...prevans.slice(0, idx),
      { ...prevans[idx], answer_id: id },
      ...prevans.slice(idx + 1),
    ]);

    dispatch(
      submitMockTest(
        JSON.stringify({
          model: model,
          section: section,
          answer: id,
          question: question.id,
          is_correct: 'true',
        })
      )
    );
  };
  return (
    <div className="mock-test-question-wrapper">
      <div className="sl-item mt-3">
        <div className="question-title-group">
          <div className="number" id={`q-${question.q_no}`}>
            {question.q_no}
          </div>
        </div>
      </div>
      <div className="type_blank">
        <div className="question-title">
          {question?.instruction ? (
            <div className="d-flex instruction-question">
              <div
                dangerouslySetInnerHTML={{ __html: question?.instruction }}
                className="px-2"
              />
            </div>
          ) : (
            ''
          )}
          <p>
            {question?.has_expression ? (
              <KatexViewer text={question?.title} />
            ) : (
              question.title
            )}
          </p>
        </div>

        <ul className="list-question">
          {question.answer.map((a, i) => (
            <li>
              <span>
                <span className="lq-number">{option[i]}</span>
                <span className="my-radio">
                  <input
                    type="radio"
                    name="q-1"
                    value={option[i]}
                    onChange={() => {
                      onAnswered('q-' + question.q_no, option[i], a.id);
                    }}
                  />
                  <img
                    src={`https://s3.ap-south-1.amazonaws.com/learnsic.com/media/public/${a.image}`}
                  />
                </span>
              </span>
            </li>
          ))}
        </ul>
      </div>

      {/* <ul className="list-question">
        {question.answer.map((a, i) => (
          <li>
            <span>
              <span className="lq-number">{option[i]}</span>
              <span className="my-radio">
                <input
                  type="radio"
                  name="q-1"
                  value={option[i]}
                  onChange={() => {
                    onAnswered('q-' + question.q_no, option[i], a.id);
                  }}
                />
                <img
                  src={`https://s3.ap-south-1.amazonaws.com/learnsic.com/media/public/${a.image}`}
                />
              </span>
            </span>
          </li>
        ))}
      </ul> */}
    </div>
  );
};

export default Template2;
